import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import WWDC from './WWDC';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <WWDC />
  </React.StrictMode>
);
